import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { profile } from '@/constants/site'
import { media } from '@/constants/media'

interface PortraitProps {
    className?: string
    caption?: boolean
}

export const Portrait: FC<PortraitProps> = ({ className, caption = true }): ReactNode => {
    return (
        <figure className={cn('flex flex-col gap-3 bg-cream p-2.5 shadow-raised', className)}>
            <div className='relative aspect-[0.857] w-full overflow-hidden bg-white'>
                <img
                    src={media.portrait}
                    alt={`Portrait of ${profile.fullName}`}
                    loading='lazy'
                    decoding='async'
                    className='absolute inset-0 size-full object-cover object-top'
                />
            </div>

            {caption && (
                <figcaption className='flex items-baseline justify-between gap-3 px-1 pb-1 text-paper'>
                    <span className='t-caps text-left'>
                        {profile.fullName}
                    </span>

                    <span className='t-meta text-right'>
                        {profile.role}
                    </span>
                </figcaption>
            )}
        </figure>
    )
}
